import React, { useContext } from 'react'
import LeftContent from 'modules/react/signup/LeftContent'
import RightContent from 'modules/react/signup/RightContent'
import SignupContext from 'modules/react/signup/SignupContext'
import FormElementError from 'modules/react/signup/FormElementError'
import CourseSummary from 'modules/react/signup/CourseSummary'
import CourseDateSelection from 'modules/react/signup/CourseDateSelection'
import ProgressBar from 'modules/react/signup/ProgressBar'
import ProgressBarStep from 'modules/react/signup/ProgressBarStep'

export default function Step2Company () {

  const signupContext = useContext(SignupContext)
  const { goBack, goToNextStep, setFormValue, submit, restUrls, setEnterCallback } = signupContext
  React.useEffect(() => {
      setEnterCallback(() => goToNextStep)
    }, []
  )

  const validateStepData = () => {
    submit(restUrls.company.validate_company)
      .then((response) => {
        goToNextStep()
      })
  }

  return (
    <>
      <LeftContent>
        <ProgressBar>
          <ProgressBarStep text={'Oplysninger'} active={true} current={true}/>
          <ProgressBarStep text={'Deltagerinformation'}/>
          <ProgressBarStep text={'Du er tilmeldt!'}/>
        </ProgressBar>

        <div className="title title--h3">Tilmelding af kursus</div>
        <div className="wysiwyg">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Animi beatae consectetur
          error molestias
          praesentium? Adipisci aliquam ex in maiores nam.
        </div>
        <CourseDateSelection/>
        <div className="title title--h6">Udfyld din virksomheds oplysninger</div>
        <div className="input-group">
          <div className="input-wrap">
            <FormElementError name="signup_name">
              <input type="text" placeholder="Dit navn:" onChange={(e) => setFormValue('signup_name', e.target.value)}/>
            </FormElementError>
          </div>
          <div className="input-group__half">
            <div className="input-wrap">
              <FormElementError name="signup_phone">
                <input type="text" placeholder="Dit telefonnr:"
                       onChange={(e) => setFormValue('signup_phone', e.target.value)}/>
              </FormElementError>
            </div>
            <div className="input-wrap">
              <FormElementError name="company_name">
                <input type="text" placeholder="Virksomhedsnavn*:"
                       onChange={(e) => setFormValue('company_name', e.target.value)}/>
              </FormElementError>
            </div>
          </div>
          <div className="input-group__half">
            <div className="input-wrap">
              <FormElementError name="cvr">
                <input type="text" placeholder="CVR-nr*:" onChange={(e) => setFormValue('cvr', e.target.value)}/>
              </FormElementError>
            </div>
            <div className="input-wrap">
              <FormElementError name="ean">
                <input type="text" placeholder="EAN-nr" onChange={(e) => setFormValue('ean', e.target.value)}/>
              </FormElementError>
            </div>
          </div>
        </div>
        <div className="button-section button-section--modal-group">
          <button className="inline-button inline-button--prim inline-button--back" onClick={goBack}>Tilbage</button>
          <button className="button button--next" onClick={validateStepData}>Tilmeld deltager</button>
        </div>
      </LeftContent>
      <RightContent>
        <CourseSummary paymentType="Virksomhed"/>
      </RightContent>
    </>
  )
}